import { post, get, put } from "@/api";

export interface OrderListGoods {
  id?: number | string;
  title?: string;
  m_pic?: string;
  [key: string]: unknown;
}

export interface OrderListItem {
  id: number | string;
  order_id?: number | string;
  goods_id?: number | string;
  spec_id?: number | string;
  goods_name?: string;
  sku_name?: string;
  unit?: string;
  quantity?: number | string;
  price?: number | string;
  amount?: number | string;
  remark?: string;
  goods?: OrderListGoods | null;
  [key: string]: unknown;
}

export interface OrderDepartment {
  id?: number | string;
  title?: string;
  [key: string]: unknown;
}

/** @deprecated 详情接口已改为 department，列表接口仍可能返回 office */
export type OrderOffice = OrderDepartment;

/** 订单审批流节点：approve_state 0待审批 / 1已审批 / 2已拒绝 */
export interface OrderFlow {
  id?: number | string;
  step_name?: string;
  step?: string;
  account_id?: number | string;
  account_name?: string | null;
  account_names?: string | null;
  account_ids?: string | null;
  approve?: string | null;
  approve_state?: number | string;
  approve_time?: string | null;
  sort?: number | string;
  now_step_sort?: number | string;
  is_over?: number | string;
  [key: string]: unknown;
}

export interface OrderRecord {
  id: number | string;
  order_sn?: string;
  state?: string;
  /** 1 = 退货订单 */
  is_backorder?: number | string;
  account_name?: string;
  account_id?: number | string;
  department_id?: number | string;
  amount?: number | string;
  total?: number | string;
  remark?: string;
  created_at?: string;
  approve_time?: string;
  delivery_time?: string;
  receive_time?: string;
  complete_time?: string;
  lists?: OrderListItem[];
  flows?: OrderFlow[];
  department?: OrderDepartment | null;
  /** 列表接口仍可能返回 office（与 department 同结构） */
  office?: OrderDepartment | null;
  /** 签收凭证图片 */
  signimgs?: Array<{
    id?: number | string;
    order_id?: number | string;
    uri?: string;
    [key: string]: unknown;
  }>;
  [key: string]: unknown;
}

export interface OrderPagesParams {
  page?: number;
  pagenumber?: number;
  search?: string;
  date_range?: string[];
  office_ids?: Array<number | string>;
  /** 商品规格 ID 筛选 */
  spec_ids?: Array<number | string>;
  state?: string[];
  /** 我的代办：仅返回当前账号待审批订单 */
  is_todo?: boolean;
}

export interface OrderPagesResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: OrderRecord[];
  total?: number;
  page?: number;
  pagenumber?: number;
}

/** 订单分页列表 */
export function getOrderPages(params: OrderPagesParams = {}) {
  return post<OrderPagesResponse>("/platform/order/pages", params);
}

export interface OrderApproveParams {
  order_id: number | string;
  /** true 同意，false 拒绝 */
  is_agree: boolean;
  remark?: string;
}

export interface OrderApproveResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 订单审批 */
export function approveOrder(params: OrderApproveParams) {
  return put<OrderApproveResponse>("/platform/order/approve", params);
}

export interface OrderUnapproveParams {
  order_id: number | string;
  remark?: string;
}

export interface OrderUnapproveResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 订单反审 */
export function unapproveOrder(params: OrderUnapproveParams) {
  return put<OrderUnapproveResponse>("/platform/order/unapprove", params);
}

export interface OrderDetailResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: OrderRecord;
}

/** 订单详情 */
export function getOrderDetail(id: number | string) {
  return get<OrderDetailResponse>(`/platform/order/detail/${id}`);
}

export interface OrderEditListItem {
  goods_id: number | string;
  spec_id: number | string;
  quantity: number;
  remark?: string;
}

export interface OrderEditParams {
  order_id: number | string;
  lists: OrderEditListItem[];
  /** 订单备注（可选） */
  remark?: string;
}

export interface OrderEditResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: OrderRecord;
  errors?: Record<string, string[]>;
}

/** 修改订单商品明细 */
export function editOrder(params: OrderEditParams) {
  return put<OrderEditResponse>("/platform/order/edit", params);
}

export interface OrderSignParams {
  order_id: number | string;
  /** 已上传的签收图片 URL 列表，最多 5 张 */
  images?: string[];
}

export interface OrderSignResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 订单签收 / 代收 */
export function signOrder(params: OrderSignParams) {
  return put<OrderSignResponse>("/platform/order/sign", params);
}

export interface OrderCancelParams {
  order_id: number | string;
  /** 取消原因 */
  remark: string;
}

export interface OrderCancelResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  errors?: Record<string, string[]>;
}

/** 取消订单 */
export function cancelOrder(params: OrderCancelParams) {
  return put<OrderCancelResponse>("/platform/order/cancel", params);
}
